import axios from "axios";
import qs from "qs";

const BASE_URL = process.env.REACT_APP_API_URL;

export const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  paramsSerializer: params =>
    qs.stringify(params, { arrayFormat: "repeat" })
});

api.interceptors.request.use(
  (config) => {
      const token = localStorage.getItem('accessToken'); // Assume token is stored in localStorage
      if (token) {
          config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
  },
  (error) => {
      return Promise.reject(error);
  }
);

